import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';

export const DrawExplainer = () => {
  const { t } = useTranslation('product');

  return (
    <div className="mb-6">
      <div className="flex flex-col gap-y-3">
        <p className="whitespace-pre-line">
          <Trans
            components={{
              0: (
                <Link
                  className="hyperlink"
                  href="https://avantarte.com"
                  target="_blank"
                />
              ),
              1: (
                <Link
                  className="hyperlink"
                  href="mailto:collecting@avantarte.com"
                  target="_blank"
                />
              ),
              2: (
                <Link
                  className="hyperlink"
                  href="/support/releases#what-is-a-draw-release"
                  target="_blank"
                />
              ),
              3: <strong />,
            }}
            i18nKey="drawExplainer.explainer"
            t={t}
          />
        </p>
      </div>
    </div>
  );
};
